<template>
    <resources-base-table
        :headers="headers"
        :inputs="inputs"
        :items="items"
        :editedItem="editedItem"
        :defaultItem="defaultItem"
        :modelService="modelService"
    >
        <template v-slot:form="{ localEditedItem }">
            <v-text-field v-model="localEditedItem['ponderable']" label="Ponderable"></v-text-field>
            <v-select
                v-model="localEditedItem.plataformaId"
                :items="plataformas"
                item-text="plataforma"
                item-value="id"
                label="Plataforma"
            ></v-select>
            <v-text-field type="number" v-model="localEditedItem['orden']" label="Orden"></v-text-field>
            <v-text-field v-model="localEditedItem['tooltip']" label="Tooltip"></v-text-field>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                        <v-checkbox v-model="localEditedItem['libre']" label="Libre"></v-checkbox>
                    </span>
                </template>
                <span>
                    Los ponderables libres son de configuración manual y provienen de un campo de la tabla usuarios.
                </span>
            </v-tooltip>

            <template v-if="localEditedItem['libre']">
                <v-text-field v-model="localEditedItem['campoOrigen']" label="Campo origen"></v-text-field>
                <v-text-field v-model="localEditedItem['tooltip']" label="Tooltip"></v-text-field>
                <v-text-field v-model="localEditedItem['valorMaximo']" label="Valor máximo"></v-text-field>
                <v-text-field v-model="localEditedItem['valorMinimo']" label="Valor mínimo"></v-text-field>
            </template>

            <template v-else>
                <v-text-field
                    type="number"
                    v-model="localEditedItem['tipoInstrumentoId']"
                    label="ID tipo instrumento"
                ></v-text-field>
                <v-text-field
                    type="number"
                    v-model="localEditedItem['asignaturaId']"
                    label="ID asignatura"
                ></v-text-field>
                <h4>Generadores instrumento</h4>
                <v-btn :disabled="processingGenerador" color="primary" @click="addGenerador(localEditedItem)">
                    Agregar generador
                </v-btn>
                <div v-for="(ponderableGenerador, index) in localEditedItem.ponderableGeneradores" :key="index">
                    <div>
                        <v-text-field
                            v-model="ponderableGenerador.generadorId"
                            label="ID generador instrumento"
                            type="number"
                        ></v-text-field>
                        <v-btn
                            :disabled="processingGenerador"
                            small
                            color="danger"
                            @click="removeGenerador(localEditedItem, index)"
                        >
                            X
                        </v-btn>
                    </div>
                </div>
            </template>
            <div>
                <label class="font-weight-medium v-label v-label--active theme--light" style="font-size: 11px;">
                    Color
                </label>
                <v-color-picker
                    v-model="localEditedItem['color']"
                    mode="hexa"
                    dot-size="20"
                    swatches-max-height="100"
                ></v-color-picker>
            </div>
        </template>
    </resources-base-table>
</template>

<script>
import { PonderablesService, PonderableGeneradoresService } from "../../../services/carreras-api.service"
import inputs from "./inputs"
import headers from "./headers"
export default {
    data() {
        return {
            modelService: PonderablesService,
            processingGenerador: false,
            inputs,
            headers,
            editedItem: {
                ponderable: "",
                ponderableGeneradores: [],
                color: "#000000"
            },
            defaultItem: {
                ponderable: "",
                ponderableGeneradores: [],
                color: "#000000"
            }
        }
    },
    props: ["items", "plataformas"],
    methods: {
        addGenerador(item) {
            item.ponderableGeneradores.push({ ponderableId: item.id, generadorId: null })
        },
        removeGenerador(item, index) {
            if (!item.ponderableGeneradores[index].id) {
                item.ponderableGeneradores.splice(index, 1)
            } else {
                this.processingImage = true
                PonderableGeneradoresService.destroy(item.ponderableGeneradores[index].id).then(() => {
                    item.ponderableGeneradores.splice(index, 1)
                    this.processingImage = false
                })
            }
        }
    }
}
</script>
